import { render, staticRenderFns } from "./wownow-image.vue?vue&type=template&id=0b58c57e&scoped=true&"
import script from "./wownow-image.vue?vue&type=script&lang=js&"
export * from "./wownow-image.vue?vue&type=script&lang=js&"
import style0 from "./wownow-image.vue?vue&type=style&index=0&id=0b58c57e&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b58c57e",
  null
  
)

export default component.exports